import React from "react"
import PropTypes from "prop-types"

class TextVerification extends React.Component {
  state = { value: "" }

  onChange = ({ target: { value } }) => {
    this.setState({ value })
    this.props.report(value === this.props.verification.text)
  }

  render() {
    const {
      verification: { prompt }
    } = this.props
    return (
      <div>
        <p>{prompt}</p>
        <input type="text" value={this.state.value} onChange={this.onChange} />
      </div>
    )
  }
}

TextVerification.propTypes = {
  verification: PropTypes.shape({
    prompt: PropTypes.node.isRequired,
    text: PropTypes.string.isRequired
  }).isRequired,
  report: PropTypes.func.isRequired
}

export default TextVerification
